<template>
  <div>
    <load-profile></load-profile>
    <!-- Table Container Card -->
    <validation-observer ref="editForm" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        key="editForm"
        @submit="submit"
        :form="$refs.editForm"
        :disabled="invalid"
      >
        <b-row>
          <b-col cols="12">
            <b-card>
              <n-input :fields="fields" v-model="data"></n-input>
            </b-card>
          </b-col>
          <b-col cols="12" class="text-right">
            <n-button-loading
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              :loading="loading"
              :disabled="invalid"
              v-if="$can('update', 'store')"
            >
              {{ $t("button.saveChanges") }}
            </n-button-loading>
            <n-button-loading
              type="button"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              :loading="loading"
              class="mt-1"
              @submit="back"
            >
              {{ $t("button.back") }}
            </n-button-loading>
          </b-col>
        </b-row>
      </n-form-confirmation>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BLink,
  BFormRadioGroup,
  BTab,
  BTabs,
  BFormTextarea,
  BButton,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import NInput from "@/components/NInput";
import formInput from "./formInput";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ManualTopUpRepository = Repository.get("manualTopUp");

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BFormRadioGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    BTab,
    BTabs,
    BFormTextarea,
    BButton,
    BCardHeader,
    BCardBody,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        zoneId: "",
        gameId: "",
        packageId: "",
      },
      initData: {
        banners: [],
      },
      loading: false,
      required,
    };
  },
  mounted() {},
  methods: {
    submit() {
      this.$refs.editForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          ManualTopUpRepository.update(this.data)
            .then((response) => {
              this.$toast.success(response.data.message);
              this.$router.push({ name: "list-transaction" });
            })
            .catch((error) => {
              if (error.response?.status == 422) {
                this.$refs.editForm.setErrors(error.response?.data?.message);
              }
            })
            .then(() => {
              this.loading = false;
            });
        }
      });
    },
    back() {
      this.$router.back();
    },
  },
  setup() {
    const fields = [...formInput];

    return { fields };
  },
};
</script>
